<template>
  <Transition name="slide-down">
    <div v-if="isVisible" class="payment-paused-banner" data-testid="payment-paused-banner">
      <div class="payment-paused-banner__container">
        <div class="payment-paused-banner__icon">
          <Icon name="heroicons:credit-card" class="w-5 h-5" />
        </div>

        <div class="payment-paused-banner__content">
          <div class="payment-paused-banner__title">
            <Icon name="heroicons:exclamation-triangle" class="w-4 h-4 inline mr-1" />
            Оплата временно приостановлена
          </div>
          <div class="payment-paused-banner__subtitle">
            Оформление заказов сейчас недоступно. Попробуйте чуть позже.
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useInstitutionStore } from '@entities/institution'

const storeInstitution = useInstitutionStore()

const isVisible = computed(() => Boolean(storeInstitution.institution?.payment_paused))
</script>

<style scoped lang="scss">
.payment-paused-banner {
  @apply
    relative
    bg-gradient-to-r from-amber-500 via-orange-500 to-red-500
    dark:from-amber-600 dark:via-orange-600 dark:to-red-600
    text-white shadow-xl border-b-2 border-amber-300/50
    dark:border-amber-400/30 overflow-hidden;

  &__container {
    @apply
      max-w-7xl mx-auto px-4 sm:px-6 lg:px-8
      py-3 flex items-center justify-center gap-3 relative z-10;
  }

  &__icon {
    @apply
      flex-shrink-0 text-white
      bg-white/20 rounded-full p-2.5
      dark:bg-white/15 shadow-lg
      border border-white/30 flex items-center justify-center;
  }

  &__content {
    @apply flex flex-col flex-1 min-w-0 text-center;
  }

  &__title {
    @apply
      flex items-center justify-center
      text-sm font-bold text-white
      drop-shadow-sm;
  }

  &__subtitle {
    @apply
      flex items-center justify-center
      text-xs text-white/95 font-medium drop-shadow-sm mt-0.5;
  }
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease-in-out;
}

.slide-down-enter-from {
  transform: translateY(-100%);
  opacity: 0;
}

.slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

@media (max-width: 640px) {
  .payment-paused-banner {
    &__container {
      @apply px-3 py-2 gap-2;
    }
    &__title {
      @apply text-xs;
    }
    &__subtitle {
      @apply text-xs;
    }
  }
}
</style>
